import { render, staticRenderFns } from "./DispatchClientFilter.vue?vue&type=template&id=09c8ae6e&scoped=true&lang=pug"
import script from "./DispatchClientFilter.vue?vue&type=script&lang=js"
export * from "./DispatchClientFilter.vue?vue&type=script&lang=js"
import style0 from "./DispatchClientFilter.vue?vue&type=style&index=0&id=09c8ae6e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8ae6e",
  null
  
)

export default component.exports